import React from "react";

/**
 * The hand-drawn wavy underline beneath emphasised phrases. Path, viewBox and
 * stroke are taken verbatim from the reference.
 *
 * Note there is deliberately no preserveAspectRatio: the reference lets it
 * default to "xMidYMid meet" so the wave scales uniformly and centres under the
 * phrase rather than stretching to the full text width.
 */
const Squiggle = ({ className }: { className?: string }) => (
  <svg
    className={className}
    viewBox="0 0 140 20"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M2 10 Q 12 -2, 22 10 T 42 10 T 62 10 T 82 10 T 102 10 T 122 10 T 138 10"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
    />
  </svg>
);

export default Squiggle;
